import { Button, Card, Col, Drawer, Form, Icon, Row } from 'antd';
import React, { Component } from 'react';
import { INPUT_TYPES, FEE_BASIS_TYPE, CHARGES_AT_TYPE, PAYMEN_FREQUENCY_TYPE } from 'constants/index';
import PropTypes from "prop-types";
import { OrderedMap } from 'immutable';
import { SLAB_FORM_FIELDS } from "constants/form-fields";

import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";

class AddSlabDrawer extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);



    onAddSlab = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.createSlab(values);
            }
        });

    }

    handleFieldValueChange = (fieldName, value) => {
        if(fieldName == "slab_fee_type"){
            this.props.form.setFieldsValue({
                slab_fee_amount: null,
                slab_fee_perc: null,
            })
        }

    }

    render() {
        return (
            <Drawer
                title={"Add Slab"}
                closable
                visible={this.props.visible}
                onClose={this.props.onClose}
                placement={"right"}
                width={"30vw"}
                footer={null}
            >
                <Row className='form'>
                    <Form key="slabForm">
                        {SLAB_FORM_FIELDS.map((field, fieldName) => {
                            if (fieldName == "slab_fee_amount") {
                                const fee_type = this.props.form.getFieldValue("slab_fee_type");
                                if (fee_type == 1) {
                                    field.disabled = false;
                                    field.rules = [
                                        {
                                            required: true,
                                            message: "Field is Required"
                                        }
                                    ];
                                } else {
                                    field.disabled = true;
                                    field.rules = [{
                                            required: false
                                    }];
                                }
                            }

                            if (fieldName == "slab_fee_perc") {
                                const fee_type = this.props.form.getFieldValue("slab_fee_type");
                                if (fee_type == 1) {
                                    field.disabled = true;
                                    field.rules = [{
                                            required: false
                                    }];
                                   
                                } else {
                                    field.disabled = false;
                                    field.rules = [
                                        {
                                            required: true,
                                            message: "Field is Required"
                                        }
                                    ];
                                }
                            }

                            return <Row>{this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName),
                                (e) => this.handleFieldValueChange(fieldName, e.target.value),
                            )()}</Row>
                        }).toList()}
                        <Col span="24" className={"p-10"}>
                            <Button type='primary' loading={this.props.loading} className={"mr-5"} onClick={this.onAddSlab}>
                                {/* <Icon type={"plus"} /> */}
                                Create Slab
                            </Button>
                        </Col>
                    </Form>
                </Row>
            </Drawer>
        )
    }
}

AddSlabDrawer.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func,
    createSlab: PropTypes.func,
    loading: PropTypes.bool
};


export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value, key) => {
                    return Form.createFormField({
                        value
                    });
                }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(AddSlabDrawer);